// import { Box, Typography } from "@mui/material";

// const TopLabel = (item) => {
//   if (!item) return null;

//   const labelParts = [
//     item.sharma,
//     item.poojaDate,
//     item.tamilMonths,
//     item.nachathiram,
//     item.thithi,
//   ].filter(Boolean);

//   if(item.tamilMonths && item.nachathiram){

//   }

//   return (
//     <Box
//       sx={{
//         padding: 1,
//         minHeight: "100px",
//         border: "1px solid #ccc",
//         height: "160px",
//       }}
//     >
//       <Typography variant="subtitle2" fontWeight="bold">
//         #{item.donorId}
//       </Typography>

//       {labelParts.length > 0 && (
//         <Typography variant="body2" fontWeight="bold">
//           {labelParts.join(" ")}
//         </Typography>
//       )}

//       <Typography variant="body1" fontWeight="bold">
//         {item.salutation}{" "}
//         {item.tributeName
//           ? item.tributeName
//           : `${item.firstName || ""} ${item.lastName || ""}`}
//       </Typography>

//       <Typography variant="body2" fontWeight="bold">{item.address}</Typography>
//       <Typography variant="body2" fontWeight="bold">{item.address1}</Typography>

//       {item.address2 && (
//         <Typography variant="body2" fontWeight="bold">{item.address2}</Typography>
//       )}

//       <Typography variant="body2" fontWeight="bold">
//         {item.city} - {item.pincode}
//       </Typography>

//       {(item.mobile1 || item.mobile2) && (
//         <Typography variant="body2" fontWeight="bold">
//           Mob.: {item.mobile1}
//           {item.mobile1 && item.mobile2 && ", "}
//           {item.mobile2}
//         </Typography>
//       )}
//     </Box>
//   );
// };

// export default TopLabel;
import { Box, Typography } from "@mui/material";

const TopLabel = (item) => {
  if (!item) return null;

  // 🔹 Determine second line based on priority
  let baseSecondLine = "";

  if (item.tamilMonths && item.nachathiram) {
    baseSecondLine = `${item.tamilMonths} ${item.nachathiram}`;
  } else if (item.tamilMonths && item.thithi) {
    baseSecondLine = `${item.tamilMonths} ${item.thithi}`;
  } else if (item.thithi) {
    baseSecondLine = item.thithi;
  } else if (item.tamilMonths) {
    baseSecondLine = item.tamilMonths;
  } else if (item.utsavam) {
    baseSecondLine = item.utsavam;
  } else if (item.poojaDate) {
    baseSecondLine = item.poojaDate;
  }

  // 🔹 Add sharma only if present
  const secondLine = item.sharma
    ? baseSecondLine
      ? `${item.sharma} ${baseSecondLine}`
      : item.sharma
    : baseSecondLine;

  return (
    <Box
      sx={{
        padding: 1,
        minHeight: "100px",
        border: "1px solid #ccc",
        height: "160px",
      }}
    >
      {/* Donor ID */}
      <Typography variant="subtitle2" fontWeight="bold">
        #{item.donorId}
      </Typography>

      {/* ✅ Second line */}
      {secondLine && (
        <Typography variant="body2" fontWeight="bold">
          {secondLine}
        </Typography>
      )}

      {/* Name */}
      <Typography variant="body1" fontWeight="bold">
        {item.salutation}{" "}
        {item.tributeName
          ? item.tributeName
          : `${item.firstName || ""} ${item.lastName || ""}`}
      </Typography>

      {/* Address */}
      <Typography variant="body2" fontWeight="bold">{item.address}</Typography>
      <Typography variant="body2" fontWeight="bold">{item.address1}</Typography>

      {item.address2 && (
        <Typography variant="body2" fontWeight="bold">{item.address2}</Typography>
      )}

      <Typography variant="body2" fontWeight="bold">
        {item.city} - {item.pincode}
      </Typography>

      {(item.mobile1 || item.mobile2) && (
        <Typography variant="body2" fontWeight="bold">
          Mob.: {item.mobile1}
          {item.mobile1 && item.mobile2 && ", "}
          {item.mobile2}
        </Typography>
      )}
    </Box>
  );
};

export default TopLabel;
